"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const graphql_tag_1 = __importDefault(require("graphql-tag"));
const getPersistentData = graphql_tag_1.default `
  query($environmentId: String!, $key: String!, $agentId: String) {
    getPersistentData(environmentId: $environmentId, key: $key, agentId: $agentId) {
      environmentId
      key
      value
      agentId
    }
  }
`;
exports.default = getPersistentData;
//# sourceMappingURL=getPersistentData.js.map